export const JiraSoftwareMarkBrand = () => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M42.692 22.8912L25.652 5.85122L24 4.19922L11.172 17.0272L5.308 22.8912C4.696 23.5032 4.696 24.4962 5.308 25.1092L17.027 36.8282L24 43.8012L36.828 30.9732L37.027 30.7742L42.691 25.1102C43.303 24.4982 43.303 23.5052 42.691 22.8922L42.692 22.8912ZM24 29.8552L18.145 24.0002L24.001 18.1442L29.856 23.9992L24 29.8552Z"
			fill="#1D7AFC"
		/>
		<path
			d="M24 18.1442C20.163 14.3072 20.152 8.09716 23.96 4.24316L11.15 17.0532L18.123 24.0262L24.002 18.1472L24 18.1452V18.1442Z"
			fill="url(#paint0_linear_818_577)"
		/>
		<path
			d="M29.872 23.9844L24 29.8564C27.85 33.7074 27.85 39.9504 24 43.8004L36.844 30.9574L29.871 23.9844H29.872Z"
			fill="url(#paint1_linear_818_577)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_818_577"
				x1="22.956"
				y1="12.2212"
				x2="14.779"
				y2="20.3972"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.176" stopColor="#0055CC" />
				<stop offset="1" stopColor="#1D7AFC" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_818_577"
				x1="25.12"
				y1="35.7094"
				x2="33.28"
				y2="27.5494"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.176" stopColor="#0055CC" />
				<stop offset="1" stopColor="#1D7AFC" />
			</linearGradient>
		</defs>
	</svg>
);
